import { render, staticRenderFns } from "./PackageDetailDialog.vue?vue&type=template&id=25d33d77&scoped=true"
import script from "./PackageDetailDialog.vue?vue&type=script&lang=js"
export * from "./PackageDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./PackageDetailDialog.vue?vue&type=style&index=0&id=25d33d77&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d33d77",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25d33d77')) {
      api.createRecord('25d33d77', component.options)
    } else {
      api.reload('25d33d77', component.options)
    }
    module.hot.accept("./PackageDetailDialog.vue?vue&type=template&id=25d33d77&scoped=true", function () {
      api.rerender('25d33d77', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/Package/PackageDetailDialog.vue"
export default component.exports